import { OrderContext } from "libs/contexts"
import { useCallback, useMemo, useState } from "react"

type OrderContextProviderProps = {
  children: React.ReactNode
}

export default function OrderContextProvider({
  children,
}: OrderContextProviderProps) {
  const [order, setOrder] = useState<OrderInfo>({})
  const [tradeList, setTradeList] = useState<TradeDetail.TradeItemEntity[]>([])

  const clearTradeList = useCallback(() => {
    setTradeList([])
  }, [])

  const orderContextValue = useMemo(
    () => ({
      order,
      setOrder,
      tradeList,
      setTradeList,
      clearTradeList,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [order, setOrder, tradeList, setTradeList],
  )

  return (
    <OrderContext.Provider value={orderContextValue}>
      {children}
    </OrderContext.Provider>
  )
}
